/* cr-tally.js: a scarcity tally. Portable, data-attribute driven.

   <div data-tally data-tally-to="100" data-tally-ms="1500">
     <span data-tally-n>100</span>          counts 0 -> to, zero-padded to its digits
     <div class="...cells"><i style="--i:0"></i> ...</div>   lit by CSS on .is-on
   </div>

   On first sight the element gets .is-on (CSS staggers the cells with --i) and
   the number counts up over data-tally-ms, so the two land together. The markup
   ships the FINAL number, and the stylesheet only dims the cells under html.js,
   so without script, or under reduced motion, it reads 100 and full. */
(function () {
  function run(el) {
    var to = parseInt(el.getAttribute('data-tally-to'), 10) || 0;
    var ms = parseInt(el.getAttribute('data-tally-ms'), 10) || 1500;
    var nums = el.querySelectorAll('[data-tally-n]');
    var width = String(to).length;
    function show(v) {
      var s = String(v); while (s.length < width) s = '0' + s;
      for (var i = 0; i < nums.length; i++) nums[i].textContent = s;
    }
    el.classList.add('is-on');
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) { show(to); return; }
    var t0 = null;
    show(0);
    function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / ms);
      show(Math.round(to * k));
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function boot() {
    var all = document.querySelectorAll('[data-tally]');
    if (!('IntersectionObserver' in window)) { for (var i = 0; i < all.length; i++) all[i].classList.add('is-on'); return; }
    // threshold 0 with a bottom inset, not a ratio: a ratio never fires on an
    // element taller than the viewport or clipped by a clip-path
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.unobserve(en.target); run(en.target); }
      });
    }, { rootMargin: '0px 0px -30% 0px', threshold: 0 });
    for (var j = 0; j < all.length; j++) { all[j].classList.add('is-armed'); io.observe(all[j]); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
